import React, { PureComponent } from 'react';
import { ActionCreators } from '@redux-devtools/core';
import LogMonitorButton from './LogMonitorButton.js';
const { reset, rollback, commit, sweep } = ActionCreators;
const style = {
    textAlign: 'center',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderColor: 'transparent',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'row',
};
export default class LogMonitorButtonBar extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleRollback = () => {
            this.props.dispatch(rollback());
        };
        this.handleSweep = () => {
            this.props.dispatch(sweep());
        };
        this.handleCommit = () => {
            this.props.dispatch(commit());
        };
        this.handleReset = () => {
            this.props.dispatch(reset());
        };
    }
    render() {
        const { theme, hasStates, hasSkippedActions } = this.props;
        return (React.createElement("div", { style: { ...style, borderColor: theme.base02 } },
            React.createElement(LogMonitorButton, { theme: theme, onClick: this.handleReset, enabled: true }, "Reset"),
            React.createElement(LogMonitorButton, { theme: theme, onClick: this.handleRollback, enabled: hasStates }, "Revert"),
            React.createElement(LogMonitorButton, { theme: theme, onClick: this.handleSweep, enabled: hasSkippedActions }, "Sweep"),
            React.createElement(LogMonitorButton, { theme: theme, onClick: this.handleCommit, enabled: hasStates }, "Commit")));
    }
}
